export async function localizacaoAtual() {
    return new Promise((resolve) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                let latitude = position.coords.latitude;
                let longitude = position.coords.longitude;

                resolve({ error: false, msg: null, latitude, longitude });
            }, (error) => {
                if (error.message == "User denied Geolocation") {
                    resolve({ error: true, msg: "Habilite a geolocalização do navegador!", latitude: null, longitude: null });
                } else {
                    resolve({ error: true, msg: error.message, latitude: null, longitude: null });
                }
            },
                {
                    enableHighAccuracy: true,  // Solicita a maior precisão possível
                    timeout: 10000,            // Tempo limite de 10 segundos
                    maximumAge: 0              // Não use cache de posição
                });
        } else {
            resolve({ error: true, msg: "Geolocalização não suportada pelo navegador", latitude: null, longitude: null });
        }
    });
}